var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M140 20c49.706 0 90 39.797 90 88.889 0 58.048-59.971 125.351-82.005 148.119-4.423 4.571-11.567 4.571-15.99 0C109.971 234.24 50 166.937 50 108.889 50 59.797 90.294 20 140 20m0 60c-16.569 0-30 13.432-30 30 0 16.569 13.431 30 30 30s30-13.431 30-30c0-16.568-13.431-30-30-30"
})));
export default SvgMapView;